// EditorFilterStrip — Ansehen/Filtern-Ebene des Editors (Spec Abschnitt 2).
// Bearbeiten liegt separat im schwebenden FloatingAddDock.
import React from 'react';
import FilterStrip from '../../../ui/FilterStrip';
import SyntaxHelpPopover from '../../../ui/SyntaxHelpPopover';
import PageSettingsPopover from '../../../ui/PageSettingsPopover';
import { Layers, Rows3, Table2, AlignJustify } from 'lucide-react';
import { DEFAULT_COLUMN_COUNT, DEFAULT_BRIDGE_SIDE } from '../../../hooks/useEditorPreferences.js';

const VIEW_ICONS = { stacks: Layers, rows: Rows3, table: Table2, compact: AlignJustify };
const VIEW_LABELS = { stacks: 'Stapel', rows: 'Zeilen', table: 'Tabelle', compact: 'Kompakt' };

export default function EditorFilterStrip({
  searchTerm, onSearchTermChange,
  sortBy, onSortByChange, sortOptions,
  groupingMode, onGroupingModeChange, groupingStrategies,
  showExcluded, onToggleShowExcluded,
  viewMode, onViewModeChange,
  columnCount, onColumnCountChange, minColumns, maxColumns,
  bridgeSide, onBridgeSideChange,
}) {
  const viewOptions = Object.keys(VIEW_LABELS).map((key) => ({
    value: key,
    label: VIEW_LABELS[key],
    icon: VIEW_ICONS[key],
  }));
  const columnOptions = Array.from(
    { length: maxColumns - minColumns + 1 },
    (_, i) => ({ value: String(minColumns + i), label: `${minColumns + i} Spalten` })
  );
  const columnsRelevant = viewMode === 'stacks' || viewMode === 'rows';

  return (
    <FilterStrip>
      <FilterStrip.Search
        value={searchTerm}
        onChange={onSearchTermChange}
        placeholder="Suche…"
        help={<SyntaxHelpPopover />}
      />
      <FilterStrip.Item id="nicht-im-deck" active={showExcluded}>
        <FilterStrip.Group label="Nicht im Deck">
          <FilterStrip.Pill
            value={showExcluded ? 'Sichtbar' : 'Ausgeblendet'}
            active={showExcluded}
            onClick={onToggleShowExcluded}
          />
        </FilterStrip.Group>
      </FilterStrip.Item>
      <FilterStrip.RightGroup>
        <FilterStrip.Item id="gruppieren">
          <FilterStrip.Group label="Gruppieren">
            <FilterStrip.PillMenu
              mode="single"
              options={Object.values(groupingStrategies).map((s) => ({ value: s.key, label: s.label }))}
              value={groupingMode}
              onChange={onGroupingModeChange}
            />
          </FilterStrip.Group>
        </FilterStrip.Item>
        <FilterStrip.Item id="sortierung">
          <FilterStrip.Group label="Sortierung">
            <FilterStrip.PillMenu
              mode="single"
              options={sortOptions.map((o) => ({ value: o.value, label: o.label }))}
              value={sortBy}
              onChange={onSortByChange}
            />
          </FilterStrip.Group>
        </FilterStrip.Item>
        <FilterStrip.Item id="ansicht">
          <FilterStrip.Group label="Ansicht">
            <FilterStrip.PillMenu mode="single" options={viewOptions} value={viewMode} onChange={onViewModeChange} />
          </FilterStrip.Group>
        </FilterStrip.Item>
        <PageSettingsPopover hasChanges={columnCount !== DEFAULT_COLUMN_COUNT || bridgeSide !== DEFAULT_BRIDGE_SIDE}>
          <PageSettingsPopover.Section label="Anzeige">
            {columnsRelevant && (
              <PageSettingsPopover.Select
                label="Spaltenzahl"
                value={String(columnCount)}
                onChange={(v) => onColumnCountChange(Number(v))}
                options={columnOptions}
              />
            )}
            <PageSettingsPopover.Radio
              name="bridge-side"
              value={bridgeSide}
              onChange={onBridgeSideChange}
              options={[
                { value: 'left', label: 'Brücke links' },
                { value: 'right', label: 'Brücke rechts' },
              ]}
            />
          </PageSettingsPopover.Section>
        </PageSettingsPopover>
      </FilterStrip.RightGroup>
    </FilterStrip>
  );
}
